/** A new row's key in a wizard step's list: unique however many rows the draft
 *  already holds. Saved rows keep the id PMS gave them. */
export function newRowKey(): string {
  return `new-${crypto.randomUUID()}`;
}
